import {
  Button,
  DropdownPortal,
  HorizontalDivider,
  Icon,
  Typography
} from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useCreatePriceLabel } from '@hero/hooks';

import * as S from './style';

const shareDropdownOptions = {
  modifiers: [
    {
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, 16]
      }
    },
    {
      name: 'flip',
      enabled: true,
      options: {
        padding: 24,
        rootBoundary: 'viewport',
        allowedAutoPlacements: ['right-start', 'right-end', 'left-start', 'left-end']
      }
    },
    {
      name: 'zIndex',
      enabled: true,
      phase: 'write',
      fn: ({ state }) => {
        state.styles.popper.zIndex = '20000'; // İstediğiniz z-index değerini buraya yazın
      }
    }
  ]
};

const content = {
  gpt: {
    estimatedShippingFeeValue: 'calculatedAtCheckout',
    footerInfoKey: 'feeBreakdownModalShippingDesc'
  },
  fpt: {
    footerInfoKey: 'feeBreakdownModalServiceDesc'
  }
};
export function PriceBreakdownDropdown({ product }) {
  const { t } = useTranslation();
  const shippingType = product?.meta?.shipmentType?.toLowerCase();
  const { merchandiseLabel, priceLabel, serviceChargeLabel } = useCreatePriceLabel(product);

  const onDropdownButtonClick = ({ e, setIsMenuOpen }) => {
    e.stopPropagation();
    setIsMenuOpen(true);
  };

  return (
    <DropdownPortal
      popperOptions={{
        placement: 'right-end',
        ...shareDropdownOptions
      }}
      referenceComponent={({ setIsMenuOpen }) => (
        <Button
          variant="link"
          style={{
            fontSize: 12,
            color: 'var(--color-fg-weaker)',
            whiteSpace: 'pre-wrap',
            textAlign: 'left'
          }}
          onClick={e => onDropdownButtonClick({ e, setIsMenuOpen })}
        >
          {product?.meta?.shipmentType && t(`${product?.meta?.shipmentType}CardLinkText`)}
        </Button>
      )}
    >
      {({ setIsMenuOpen, setPortalRef }) => (
        <S.PriceBreakdownDropdown
          ref={setPortalRef}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <S.DropdownHeader>
            <Typography variant="body2Bold">{t('priceBreakdown')}</Typography>
            <Button
              variant="link"
              onClick={e => {
                e.stopPropagation();
                setIsMenuOpen(false);
              }}
            >
              <Icon name="close" color="var(--color-neutral-800)" />
            </Button>
          </S.DropdownHeader>

          <S.DropdownBody>
            <S.DropdownBodyItem>
              <Typography variant="body2">{t('merchandise')}</Typography>
              <Typography variant="body2">{merchandiseLabel}</Typography>
            </S.DropdownBodyItem>
            <S.DropdownBodyItem>
              <Typography variant="body2">
                {t(shippingType === 'fpt' ? 'estimatedServiceFee' : 'estimatedShippingFee')}
              </Typography>
              <Typography variant="body2">
                {t(content[shippingType]?.estimatedShippingFeeValue) || serviceChargeLabel}
              </Typography>
            </S.DropdownBodyItem>
            <HorizontalDivider />
            <S.DropdownBodyItem>
              <Typography variant="body2Bold">
                {t(
                  shippingType === 'fpt'
                    ? 'estimatedTotalBeforeTaxes'
                    : 'estimatedTotalBeforeShippingTaxes'
                )}
              </Typography>
              <Typography variant="body2Bold" style={{ minWidth: 'max-content' }}>
                {priceLabel}
              </Typography>
            </S.DropdownBodyItem>
            <HorizontalDivider />
            <Typography variant="caption1" emphasis="weak">
              {t(content[shippingType]?.footerInfoKey)}
            </Typography>
          </S.DropdownBody>
        </S.PriceBreakdownDropdown>
      )}
    </DropdownPortal>
  );
}

PriceBreakdownDropdown.propTypes = {
  product: PropTypes.object
};
